import { Grid2 as Grid, Typography } from "@mui/material";

interface ProductDetailRowProps {
  label: string;
  value?: React.ReactNode;
  labelWidth?: number;
  valueWidth?: number;
}

export const ProductDetailRow: React.FC<ProductDetailRowProps> = ({
  label,
  value = "-",
  labelWidth = 5,
  valueWidth = 7,
}) => (
  <>
    <Grid size={labelWidth}>
      <Typography 
        fontWeight={500}
        fontSize="0.8125rem"
        color="text.secondary"
      >
        {label}
      </Typography>
    </Grid>
    <Grid size={valueWidth}>
      <Typography fontSize="0.8125rem">{value}</Typography>
    </Grid>
  </>
);
